<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="650"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Edit country</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column h-550px scroll-y mx-5 mx-xl-15 py-7"
      >
        <div class="h-75px">
          <v-text-field
            v-model="formData.title"
            dense
            :label="$t('title')"
            clearable
            outlined
          ></v-text-field>
        </div>
        <div class="h-75px">
          <v-text-field
            v-model="formData.iso_3"
            dense
            :label="$t('iso_3')"
            clearable
            outlined
          ></v-text-field>
        </div>
        <div class="h-75px">
          <v-text-field
            v-model="formData.iso_2"
            dense
            :label="$t('iso_2')"
            clearable
            outlined
          ></v-text-field>
        </div>
        <div class="h-75px">
          <v-autocomplete
            v-model="formData.currency_id"
            dense
            :label="$t('currency')"
            item-text="text"
            item-value="index"
            clearable
            outlined
            :items="currencies"
            hide-no-data
            hide-selected
          ></v-autocomplete>
        </div>
        <div class="h-75px">
          <v-text-field
            v-model="formData.phone_code"
            dense
            :label="$t('phone_code')"
            clearable
            outlined
          ></v-text-field>
        </div>
        <!--begin::Actions-->
        <div class="mb-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetCreateForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitCreateForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import countryEditMixin from "@/own/mixins/countryEditMixin";

export default {
  name: "EditCountry",
  props: ["id", "editType"],
  mixins: [countryEditMixin],
  data: () => ({
    dialog: false,
    formData: {
      title: null,
      iso_3: null,
      iso_2: null,
      currency_id: null,
      phone_code: null,
    },
  }),
  computed: {
    currencies: function () {
      return this.$store.getters.getSHIPPINGCOUNTRIESCurrencies;
    },
  },
  methods: {
    submitCreateForm() {
      let sendData = {
        type: `${this.editType}`,
        ...this.formData,
      };
      this.sentToApi(sendData);
    },
    resetCreateForm() {
      this.formData = {
        title: null,
        iso_3: null,
        iso_2: null,
        currency_id: null,
        phone_code: null,
      };
    },
  },
};
</script>
